import Vue from 'vue'

export const eventhub = new Vue()
export const EVENT_ORDER_PICKUP='order:pickup'

export default eventhub
